import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {BaseListComponent} from '../../abstract/base-list.component';
import {ActivatedRoute, Router} from '@angular/router';
import {PaymentComponent} from '../../paymemtModule/payment/payment.component';
import {DatePipe, isPlatformBrowser} from '@angular/common';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PaymentModel} from '../../data/model/PaymentModel/payment.model';
import {ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import {BankAccountModel} from '../../data/model/BankAccountModel/bank-account.model';
import {Highlight} from '../../shared/highlights/highlight';
import {Subject} from 'rxjs';
import {AppConstants} from '../../shared/constants/app-constants';
import {debounceTime} from 'rxjs/operators';
import {ApiTokenComponent} from '../../dialogs/api-token/api-token.component';
import {GetBankAccountHistoryListAction} from './get-bank-account-history-list.action';
import {ErrorConstants} from '../../shared/constants/error-constants';
import {RequestDetailsComponent} from '../../dialogs/request-details/request-details.component';
import {ExportModel} from '../../data/model/ExportModel/export-model';
import {ExportConstants} from '../../shared/constants/export-constants';

@Component({
  selector: 'app-change-request-history',
  templateUrl: './change-request-history.component.html',
  styleUrls: ['./change-request-history.component.css'],
})
export class ChangeRequestHistoryComponent extends GetBankAccountHistoryListAction implements OnInit, OnDestroy {
  showExport = false;
  exportExcel: ExportModel[] = ExportConstants.bankAccountChangeRequestListExport;
  exportData: Object;
  from_date: any;
  to_date: any;
  runActionDialog;
  today: Date = new Date();
  changeRequestList: ApiResponseModel<BankAccountModel>;
  _service_name = '/merchant_bank_accounts/history';
  constructor(private _route: ActivatedRoute, router: Router, private datePipe: DatePipe,
              route: ActivatedRoute,
              private dialog: MatDialog, dataManager: DataManagerService, @Inject(PLATFORM_ID) private platformId: any,
              @Inject('LOCALSTORAGE') private localStorage: any, snackBar: MatSnackBar) {
    super();
    this.exportData = {
      exportServiceName: AppConstants.SERVICE_NAME_EXPORT_DASHBOARD + '/change-request',
      redirectUrl: '/merchant/branding/change-request-history',
      cancelRedirectUrl: '/merchant/branding/change-request-history',
      fileName: 'Payarc_Bank_Account_Change_Request_History_Report',
      heading: 'Bank Account Change Request History',
    };
    this.dataManager = dataManager;
    this.snackBar = snackBar;
    this.changeRequestList = new ApiResponseModel<BankAccountModel>();
    this.searchHits = new Subject();
    this.alertDialog = dialog;
    this.errorMsg = null;
    this.route = route;
    this.router = router;
    this.getListUrl = AppConstants.BASE_URL + this._service_name;
  }
  ngOnInit(): void {
    this.searchHits.pipe(debounceTime(600), ).subscribe((res) => {
      if (!this.isNullOrUndefined(this.searchText)) {
        this.setUrl();
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      if (
        !this.localStorage.getItem(this.filter_storage_key) &&
        !this.localStorage.getItem(this.count_storage_key)
      ) {
        this.setUrl();
      }
    }
  }
  limitChange() {
    this.setUrl();
  }
  paginate(paginateExtension) {
    this.getList(paginateExtension);
    this.loadFlag = true;
  }
  highlight(value) {
    return Highlight.highlight(value, this.searchText);
  }
  reveal(item) {
    this.openRevealModal(item);
  }
  async openRevealModal(item) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'request-details-dialog';
    dialogConfig.width = '1000px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: item.id,
      status: item.history_status,
      requested_at: item.requested_at,
      completed_at: item.history_status === 'Update completed' ? item.updated_at : null,
      reason: item.reason,
      note: item.note,
      upload_link: item.upload_link,
      // PDT-32072 (AC-08): pended requests expose what Risk asked for and accept
      // the merchant's response (note + documents) straight from this dialog.
      can_respond: item.can_respond === true,
      pend_note: item.pend_note,
      pend_documents: item.pend_documents || []
    };
    this.runActionDialog = this.alertDialog.open(RequestDetailsComponent, dialogConfig);
    this.runActionDialog.afterClosed().subscribe((result) => {
      if (result === 'responded') {
        this.showSnackBar('Your response was submitted. Our Risk team will review it shortly.', 'Ok', 5000);
        this.setUrl();
      }
    });
  }
  checkdate() {
    if (!this.isNull(this.from_date) && this.from_date.toString() === 'Invalid Date') {
      this.datereport();
    }
  }

  checkdate2() {

    if (!this.isNull(this.to_date) && this.to_date.toString() === 'Invalid Date') {
      this.datereport();
    }
  }
  datereport() {
    if ((this.from_date && this.from_date.toString() === 'Invalid Date') || (this.to_date && this.to_date.toString() === 'Invalid Date')) {
      this.showSnackBar('Enter valid date.', 'Ok', 3000);
    } else if ((this.isNullOrUndefined(this.from_date)) || this.isNullOrUndefined(this.to_date)) {
      if ((!this.isNullOrUndefined(this.searchText) && (this.isNull(this.from_date) && this.isNull(this.to_date)))
        || (this.isNullOrUndefined(this.searchText) && (this.isNull(this.from_date) && this.isNull(this.to_date)))) {
        this.from = new Date(this.from + ' 00:00:00').toISOString();

        this.to = (this.isNullOrUndefined(this.to_date) ? '' : (this.datePipe.transform(this.to_date, 'yyyy-MM-dd')));
        this.to = new Date(this.to + ' 23:59:59').toISOString();
        this.setUrl();

      } else {
        return;
      }
    } else if (this.from_date > this.to_date) {
      this.showSnackBar('From date should not exceed ' + this.datePipe.transform(this.to_date, 'MM/dd/yyyy') + '.', 'Ok', 3000);
    } else {
      this.from = (this.isNullOrUndefined(this.from_date) ? '' : (this.datePipe.transform(this.from_date, 'yyyy-MM-dd')));
      this.to = (this.isNullOrUndefined(this.to_date) ? '' : (this.datePipe.transform(this.to_date, 'yyyy-MM-dd')));
      this.from = new Date(this.from + ' 00:00:00').toISOString();

      this.to = (this.isNullOrUndefined(this.to_date) ? '' : (this.datePipe.transform(this.to_date, 'yyyy-MM-dd')));
      this.to = new Date(this.to + ' 23:59:59').toISOString();
      this.setUrl();
    }
  }
  protected getListErr(err) {
    this.errorMsg = this.networkErrorHandler(err.error, ErrorConstants.bankAccountHistoryErrorMsg);
  }
  protected getListRes(bankAccountHistoryListResponse: ApiResponseModel<BankAccountModel>) {
    this.changeRequestList = bankAccountHistoryListResponse;
    this.metadata = bankAccountHistoryListResponse.meta.pagination;
    if (this.changeRequestList.data.length === 0) {
      this.errorMsg = ErrorConstants.bankAccountHistoryErrorMsg[0];
    } else {
      this.errorMsg = null;
    }
  }

  openexcel(): void {
    this.showExport = true;
    this.exportData['include'] = '&full_path=App\\Containers\\AppSection\\ChangeRequest\\Data\\Repositories\\&is_full_path=1';
  }
}
